import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { useDispatch, useSelector } from 'react-redux';
import { PricingActions } from 'state/modules/pricing';
import { CreditTypeSelect } from 'components/AsyncFields';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { FETCH_STATE } from 'constants';
import { promoCodesActions } from 'state/modules/promoCodes';

const UpdateAccountingModal = ({ id, promoCode, open, handleClick }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { updatePromoCode } = useSelector((state) => state.promoCodes);

  const CreditTypeSchema = Yup.object().shape({
    invoice_item_type_id: Yup.string().required(i18n.t('common.required_field')),
  });

  const handleSubmit = (values) => {
    dispatch(promoCodesActions.updatePromoCode(promoCode, values));
  };

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  useEffect(() => {
    if (updatePromoCode === FETCH_STATE.DONE) {
      dispatch(promoCodesActions.updatePromoCodeReset());
      handleClick();
    }
  }, [updatePromoCode]); // eslint-disable-line

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('common.update')}
      loading={updatePromoCode === FETCH_STATE.LOADING}
      title={i18n.t('promo_codes.edit_credit_type')}
    >
      <Formik
        innerRef={formRef}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        initialValues={{ invoice_item_type_id: id || '' }}
        validationSchema={CreditTypeSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Box mt={1}>
              <Field name="invoice_item_type_id" component={CreditTypeSelect} />
            </Box>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

UpdateAccountingModal.propTypes = {
  id: PropTypes.any.isRequired,
  promoCode: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

UpdateAccountingModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default UpdateAccountingModal;
